import z from 'zod';

export const addEventSchema = z.object({
  types: z.array(z.string()).min(1, 'At least one type is required'),
  name: z
    .string()
    .min(3, { message: 'The name must contain at least 3 characters' })
    .max(100, { message: 'The name must contain a maximum of 100 characters' })
    .regex(/^[a-zA-Z0-9 ]+$/, {
      message: 'The name must not contain any special characters',
    }),
  startDate: z.string().refine((val) => !isNaN(Date.parse(val)), {
    message: 'Start date is required',
  }),
});
